import { computed } from "vue";
import { useBreakpoints } from "./useBreakpoints";
import { useModifiers } from "./useModifiers";

const { isSmScreen } = useBreakpoints();

export function useVariant(props) {
  const variant = computed(() => (isSmScreen.value && props.smVariant ? props.smVariant : props.variant));
  const modifiersProps = computed(() => ({ variant: variant.value }));
  const { modifiers } = useModifiers(modifiersProps, "variant");
  const variantModifiers = computed(() => modifiers.value);

  return {
    variantModifiers,
  };
}
